function createDiv(id ="", classList = []) {
    let div = document.createElement("div");

    if (id == "") {
        id = false;
    }

    if (id) {
        div.setAttribute("id", id);
    }

    classList.forEach(element => {
        div.classList.add(element);
    });
    return div;
}

function createLabel(_for) {
    let label = document.createElement("label");
    label.setAttribute("for", _for);
    return label;
}

function createInput(type, classList = [], id = "", name, attrs = []) {
    let input = document.createElement("input");
    input.setAttribute("type", type);
    input.setAttribute("id", id);
    input.setAttribute("name", name);
    
    classList.forEach(element => {
        input.classList.add(element);
    });
    
    attrs.forEach(element => {
        
        let key = element.key;
        let value = element.value;
        
        if (key == "required") {
            value = "";
        }
        input.setAttribute(key, value);
    });
    
    return input;
    
}

function createTextArea(classList = [], id = "", name, rows, attrs =[]) {
    let textarea = document.createElement("textarea");
    classList.forEach(element => {
        textarea.classList.add(element);
    });
    textarea.setAttribute("id",id);
    textarea.setAttribute("name", name);
    textarea.setAttribute("rows", rows);
    attrs.forEach(element => {
        textarea.setAttribute(element.key, element.value);
    });
    
    return textarea;
}

function createFlashElement(parentElement) {
    
    let ele = document.createElement("div");
    ele.style.textAlign = "left";
    ele.setAttribute("id", "flashMessage");
    parentElement.appendChild(ele);
    
}

function toTitleCase(str) {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
    }
    return str.join(' ');
}

function addStar(txt, req) {
    let labelText = txt
    if (req) {
        labelText = labelText+"*";
    }
    
    return labelText
}

function createOption(args = []) {
    return createDOMElement("option", undefined, [], args);
}

function createImg(elementid, imgsrc, classList, attrs) {
    if (!attrs) {
        attrs = [];
    }
    attrs.push({"key":"src", "value":imgsrc});
    return createDOMElement("img", elementid, classList, attrs)
}

function createImageElement(imgsrc, elementid, imgClassList, wrapperClassList) {
    let image_wrapper = createDiv(elementid, wrapperClassList);
    image_wrapper.appendChild(createImg("img_"+elementid, imgsrc, imgClassList));
    return image_wrapper;
    
}

function createDOMElement(type, id, classList = [], attrs = []) {
    let ele = document.createElement(type);
    
    classList.forEach(element => {
        ele.classList.add(element);
    });
    
    attrs.forEach(element => {
        ele.setAttribute(element.key, element.value);
    });
    
    if (id) {
        ele.id = id;
    }
    
    return ele;
    
}

function createRows(parentElementId, data) {
    let parentElement = document.getElementById(parentElementId);
    data.forEach(element => {
        let row = createDiv(["row"]);
        let span = createDOMElement("span");
        let deleteButton = createDOMElement("i", undefined, classList = ["bx", "bxs-x-square"] ) 
        span.innerHTML = element;
        row.appendChild(span);
        row.appendChild(deleteButton);
        parentElement.appendChild(row);
    });
}

function createSimpleTable(parentElementId, jsondata) {
    let dictlist = [];
    console.log(jsondata);
    for (const [key, value] of Object.entries(jsondata)) {
        dictlist.push({"key":key, "value":value})
    }
    
    convertJsonToTable(parentElementId, dictlist);
}

function createElements(parentElement, formAttributes) {
    console.log(formAttributes, typeof formAttributes);
    formAttributes.forEach((element) => {
        // console.log(element);
        switch (element.type) {

            case "bool":
                var row = createDiv(["row"])
                var labeldiv = createDiv(["col-25"]);
                var label = createLabel(element.attributeName.replace(/ /g, "_"));
                var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
                label.innerHTML = addStar(labelText, element.required);
                labeldiv.appendChild(label);
                row.appendChild(labeldiv);

                var inputdiv = createDiv(["col-75"]);
                var input_radio = document.createElement("input");
                input_radio.type = "checkbox";
                input_radio.id = element.attributeName.replace(/ /g, "_");
                input_radio.name = element.attributeName.replace(/ /g, "_");
                input_radio.value = true;

                inputdiv.appendChild(input_radio);
                row.appendChild(inputdiv)
                parentElement.appendChild(row);
            break;

            case "input-text":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var label = createLabel(element.attributeName.replace(/ /g, "_"));
            
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            var inputdiv = createDiv(["col-75"]); 
            var input = createInput("text", [], element.attributeName.replace(/ /g, "_"), element.attributeName.replace(/ /g, "_"), [{"key":"required", "value":element.required}]);
            if(element.value) {
                input.value = element.value;
            }
            
            if (element.attributeName == "uid") {
                input.disabled = true;
            }
            
            inputdiv.appendChild(input);
            row.appendChild(inputdiv)
            parentElement.appendChild(row);
            
            break;
            
            case "input-number":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var label = createLabel(element.attributeName.replace(/ /g, "_"));
            
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            
            var inputdiv = createDiv(["col-75"]); 
            var input = createInput("number", [], element.attributeName.replace(/ /g, "_"), element.attributeName.replace(/ /g, "_"), [{"key":"required", "value":element.required}]);
            inputdiv.appendChild(input);
            row.appendChild(inputdiv)
            parentElement.appendChild(row);
            
            break;

            case "input-float":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var label = createLabel(element.attributeName.replace(/ /g, "_"));
            
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            
            var inputdiv = createDiv(["col-75"]); 
            var input = createInput("number", [], element.attributeName.replace(/ /g, "_"), element.attributeName.replace(/ /g, "_"), [{"key":"required", "value":element.required},{"key":"step", "value":0.01}]);
            inputdiv.appendChild(input);
            row.appendChild(inputdiv)
            parentElement.appendChild(row);
            break;
            
            case "input-email":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var label = createLabel(element.attributeName.replace(/ /g, "_"));
            
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            
            var inputdiv = createDiv(["col-75"]); 
            var input = createInput("email", [], element.attributeName.replace(/ /g, "_"), element.attributeName.replace(/ /g, "_"), [{"key":"required", "value":element.required}]);
            inputdiv.appendChild(input);
            row.appendChild(inputdiv)
            parentElement.appendChild(row);
            
            break;
            
            case "input-tel":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var label = createLabel(element.attributeName.replace(/ /g, "_"));
            
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            
            var inputdiv = createDiv(["col-75"]); 
            var input = createInput("tel", [], element.attributeName.replace(/ /g, "_"), element.attributeName.replace(/ /g, "_"), [{"key":"required", "value":element.required}]);
            inputdiv.appendChild(input);
            row.appendChild(inputdiv)
            parentElement.appendChild(row);
            
            break;
            
            case "input-password":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var label = createLabel(element.attributeName.replace(/ /g, "_"));
            
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            
            var inputdiv = createDiv(["col-75"]); 
            var input = createInput("password", [], element.attributeName.replace(/ /g, "_"), element.attributeName.replace(/ /g, "_"), [{"key":"required", "value":element.required}]);
            inputdiv.appendChild(input);
            row.appendChild(inputdiv)
            parentElement.appendChild(row);
            
            break;
            
            
            case "textarea":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var label = createLabel(element.attributeName.replace(/ /g, "_"));
            
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            
            var inputdiv = createDiv(["col-75"]); 
            var textarea = createTextArea([], element.attributeName.replace(/ /g, "_"), element.attributeName.replace(/ /g, "_"), 3, [{"key":"required", "value":element.required}]);
            
            if(element.value) {
                textarea.value = JSON.stringify(element.value);
            }
            
            inputdiv.appendChild(textarea);
            row.appendChild(inputdiv)
            parentElement.appendChild(row);
            
            break;
            
            case "text":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var label = createLabel(element.attributeName.replace(/ /g, "_"));
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            
            var inputdiv = createDiv(["col-75"]); 
            var textarea = createTextArea([], element.attributeName.replace(/ /g, "_"), element.attributeName.replace(/ /g, "_"), 3, [{"key":"required", "value":element.required}]);
            
            if(element.value) {
                textarea.value = JSON.stringify(element.value);
            }
            
            inputdiv.appendChild(textarea);
            row.appendChild(inputdiv)
            parentElement.appendChild(row);
            
            break;
            
            case "nested_object":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var label = createLabel(element.attributeName.replace(/ /g, "_"));
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            
            var inputdiv = createDiv(["col-75"]); 
            var textarea = createTextArea([], element.attributeName.replace(/ /g, "_"), element.attributeName.replace(/ /g, "_"), 3, [{"key":"required", "value":element.required}]);
            
            if(element.value) {
                textarea.value = JSON.stringify(element.value);
            }
            
            inputdiv.appendChild(textarea);
            row.appendChild(inputdiv)
            parentElement.appendChild(row);
            
            break;
            
            case "dropdown":
            var row = createDiv(["row"]);
            var labeldiv = createDiv(["col-25"]);
            var lt = element.attributeName.replace(/ /g, "_")
            var label = createLabel(lt);
            var labelText = toTitleCase(element.attributeName.replace(/_/g, " ").toLowerCase());
            label.innerHTML = addStar(labelText, element.required);
            labeldiv.appendChild(label);
            row.appendChild(labeldiv);
            
            var dropdownDiv = createDiv(["col-75"]); 
            var datalist = createDOMElement("datalist", lt, [], [{"key":"name", "value":lt}]);
            var option = createOption([{"key":"value", "value":"Loading.."}]);
            option.innerHTML = "Loading..";
            datalist.appendChild(option);
            dropdownDiv.appendChild(datalist);
            
            var input = createInput("text", [], lt+"_list", lt, [{"key":"autocomplete", "value":"on"},{"key":"list", "value":lt},{"key":"required", "value":element.required}]);
            if (element.value) {
                console.log("Setting default value for dropdown.");
                input.value = element.value;
            }
            dropdownDiv.appendChild(input);
            
            row.appendChild(dropdownDiv);
            
            parentElement.appendChild(row);
            
            break;
            
            case "input-file":
            let fileLabel = document.createElement("label");
            fileLabel.setAttribute("for", element.attributeName.replace(/ /g, "_"));
            fileLabel.setAttribute("class", "form-label");
            fileLabel.innerHTML = element.attributeName;
            parentElement.appendChild(fileLabel);
            
            let fileInput = document.createElement("input");
            fileInput.setAttribute("type", "file");
            fileInput.setAttribute("class", "form-control");
            fileInput.setAttribute("id", element.attributeName.replace(/ /g, "_"));
            fileInput.setAttribute("name",element.attributeName.replace(/ /g, "_"));
            fileInput.setAttribute("multiple", true);
            fileInput.setAttribute("required", true);
            parentElement.appendChild(fileInput);
            
            break;
            
            default:
            console.log("Type doesn't exist!");
        }
    });
}

function loadOptions(data, pattr, parentElementid, custom) {
    custom = custom || false;
    let pele = document.getElementById(parentElementid);
    pele.innerHTML = "";
    data.forEach(element => {
        console.log(element);
        let val = element;
        let opval = val;
        if (!custom) {
            val = element[pattr]
            opval = element.uid;
        }
        var option = createOption([{"key":"value", "value":opval}]);
        option.innerHTML = val;
        pele.appendChild(option);
    });
    
}

function createButtons(parentElement, type = "formButtons") {
    let classList = ["text-center"];
    let id = undefined;
    let attrs =  undefined;
    let buttonContainer = createDOMElement("div", undefined, classList);
    buttonContainer.style.display = "flex";
    buttonContainer.style.justifyContent = "center";
    buttonContainer.style.gap = "10px";
    buttonContainer.style.margin = "10px 10px";
    

    if (type == "confirm") {
        id = "confirmBtn";
        classList=["button", "btn-float-right"], attrs =[{"key":"type", "value":"submit"}];
        let confirmButton = createDOMElement("button", id, classList);
        confirmButton.innerHTML = "Confirm";
        buttonContainer.appendChild(confirmButton);
        
        id = "skipBtn";
        classList=["button","btn-float-left"], attrs =[{"key":"type", "value":"skip"}];
        let skipButton = createDOMElement("button", id, classList);
        skipButton.innerHTML = "Skip";
        buttonContainer.appendChild(skipButton);
        
    } else {
        id = "submitBtn";
        classList=["button", "btn-float-left"];
        attrs =[{"key":"type", "value":"submit"}];
        let submitButton = createDOMElement("button", id, classList,attrs);
        
        submitButton.innerHTML = "Submit";
        
        id ="resetBtn";
        classList=["button", "btn-colour-red"];
        attrs =[{"key":"type", "value":"reset"}];
        let resetButton = createDOMElement("button", id, classList, attrs);
        
        resetButton.innerHTML = "Reset";
        
        buttonContainer.appendChild(submitButton);
        buttonContainer.appendChild(resetButton);
    }
    
    if (parentElement) {
        parentElement.appendChild(buttonContainer);    
        return;
    }
    
    return buttonContainer;
    
}

export {
createDiv,
createButtons,
loadOptions,
createImg,
createDOMElement

}